import React, { useRef } from "react";

import { LazyRemote } from "widgets/lazyremote";
import { AccountLogo, UserProfile, BaseTopNav } from "widgets/topnav";

import styles from "./styles.css";

export function PortalTopNav() {
  const currentClosePopup = useRef(null);
  const { _id: appId } = window.accountDetails?.PortalData || {};
  //TODO : We are using Base top nav. So adding a class over here for theme to be applied in Portal top nav
  let themeClass = `appTheme_${appId}`;

  return (
    <BaseTopNav className={themeClass}>
      <BaseTopNav.LeftRenderer>
        <AccountLogo
          redirectTo={`/application/${appId}`}
          className={styles.logoImg}
        />
      </BaseTopNav.LeftRenderer>
      <BaseTopNav.MiddleRenderer>
        <LazyRemote
          name="application"
          module="kfapplication/portal"
          componentName="Topnav"
          key="AppNavigation"
        />
      </BaseTopNav.MiddleRenderer>
      <BaseTopNav.RightRenderer>
        <div id="notificationavcontainer" className={styles.notificationav} />
        <UserProfile
          currentClosePopup={currentClosePopup}
          logOutUrl={`/signin/2/${window.accountDetails._id}/portal/logout`}
        />
      </BaseTopNav.RightRenderer>
    </BaseTopNav>
  );
}
